<template>
  <section>
    <b-dropdown
      v-model="tripValue"
      aria-role="list"
      @change="onChange"
      data-test="tripval_selector"
    >
      <template v-if="tripValue === 0" #trigger>
        <b-button
          label="One Way"
          type="is-outline"
          icon-left="arrow-right"
          icon-right="menu-down"
          size="is-small"
        />
      </template>
      <template v-else-if="tripValue === 1" #trigger>
        <b-button
          label="Round Trip"
          type="is-outline"
          icon-left="swap-horizontal"
          icon-right="menu-down"
          size="is-small"
        />
      </template>
      <template v-else-if="tripValue === 2" #trigger>
        <b-button
          label="Multi-city"
          type="is-outline"
          icon-left="arrow-decision-outline"
          icon-right="menu-down"
          size="is-small"
        />
      </template>

      <b-dropdown-item :value="0" aria-role="listitem" data-test="one_way">
        <div class="media">
          <b-icon class="media-left" icon="arrow-right"></b-icon>
          <div class="media-content">
            <h3>One Way</h3>
          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-item :value="1" aria-role="listitem" data-test="roundtrip">
        <div class="media">
          <b-icon class="media-left" icon="swap-horizontal"></b-icon>
          <div class="media-content">
            <h3>Round Trip</h3>
          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-item :value="2" aria-role="listitem" data-test="multi_city">
        <div class="media">
          <b-icon class="media-left" icon="arrow-decision-outline"></b-icon>
          <div class="media-content">
            <h3>Multi-city</h3>
          </div>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
export default {
  name: "TripTypeSelectorDropdown",
  props: {
    startVal: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tripValue: this.startVal,
    };
  },
  methods: {
    onChange(value) {
      this.$emit("switch", value);
    },
  },
};
</script>

<style scoped></style>
